/**
 * Created by Christof Sander on 02.02.2017.
 */

module.exports = {
	config: {
		environmentDependent: true,
		deltaDiagonal: 50,
		nrOfElementsPerScreen: {
			mobile: 4,
			desktop: 10
		},
		nrOfElementsPerRow: {
			mobile: 2,
			desktop: 5
		}
	},

	methods: {
		/**
		 * this function has to return true if the environment dependent refresh should be performed.
		 *
		 * @param   activeEnvironment               {} - active environment
		 * @param   newEnvironment                  {} - new environment
		 * @param   serverKnownEnvironment          {} - environment known by the server
		 * @param   initialExecution                boolean - is this the initial execution
		 * @param   externalDrivenCall              boolean - e.g., browser resize -> true, ibt-grid-style-change -> false
		 * @param   environmentUpdateByParent       boolean - has a parent of mine decided to refresh and already updated by own activeEnvironment
		 * @returns boolean
		 */
		environmentRefreshNecessary: function(activeEnvironment, newEnvironment, serverKnownEnvironment, initialExecution, externalDrivenCall, environmentUpdateByParent){
			// NOTE: while using dynamic images it can be useful not to respect breakPoints, styles and so on.
			var activeDiagonal  = Math.sqrt(Math.pow(activeEnvironment.dimensions.window.width, 2) + Math.pow(activeEnvironment.dimensions.window.height, 2));
			var newDiagonal     = Math.sqrt(Math.pow(newEnvironment.dimensions.window.width, 2) + Math.pow(newEnvironment.dimensions.window.height, 2));
			return (Math.abs(activeDiagonal - newDiagonal) >= this.config.deltaDiagonal);
		},

		getWindowParameters: function(environment){
			var props = {
				nrOfElements:       0,
				nrOfDynamicRows:    0,
				nrOfDynamicWindows: 0,
				scrollStep:         'full'
			};

			if(environment && environment.style && this.config.nrOfElementsPerScreen[environment.style]){
				if(this.model.scrollStep && this.model.scrollStep.data){
					props.scrollStep = this.model.scrollStep.data;
				}

				this.find('templates_team_member', function(){
					props.nrOfElements++;
				});

				props.nrOfDynamicWindows = (props.nrOfElements / this.config.nrOfElementsPerScreen[environment.style]);
				if(props.nrOfDynamicWindows != parseInt(props.nrOfDynamicWindows)) props.nrOfDynamicWindows = parseInt(props.nrOfDynamicWindows) + 1;

				props.nrOfDynamicRows = (props.nrOfElements / this.config.nrOfElementsPerRow[environment.style]);
				if(props.nrOfDynamicRows != parseInt(props.nrOfDynamicRows)) props.nrOfDynamicRows = parseInt(props.nrOfDynamicRows) + 1;
			}

			return props;
		}
	}
};